<div>
    <app-customer-feedback-form></app-customer-feedback-form>
</div>
<div>
    <app-customer-feedback-list></app-customer-feedback-list>
</div>